// extracted by mini-css-extract-plugin
export default {"submit":"Form-Btn-Submit_submit__agSCm"};